import { render, staticRenderFns } from "./IzinProvChart.vue?vue&type=template&id=d94f8726&"
import script from "./IzinProvChart.vue?vue&type=script&lang=js&"
export * from "./IzinProvChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports